import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SelectedDateRangeI } from '../../../types/ui/dateRangePickerButton';
import { DEFAULT_DATE_RANGE } from '../../../constants/fetch/events';

interface FetchEventsStateI {
    selectedDateRange: SelectedDateRangeI,
    selectedEventSubCategoryName?: string,
    isFromKnowledgeGapReport: boolean
};

const initialState: FetchEventsStateI = {
    selectedDateRange: DEFAULT_DATE_RANGE,
    isFromKnowledgeGapReport: false
};

export const fetchEventsSlice = createSlice({
    name: 'fetch-events',
    initialState,
    reducers: {
        setSelectedDateRange: (state, action: PayloadAction<SelectedDateRangeI>) => {
            state.selectedDateRange = action.payload;
        },
        setSelectedEventSubCategoryName: (state, action: PayloadAction<string>) => {
            state.selectedEventSubCategoryName = action.payload;
        },
        setIsFromKnowledgeGapReport: (state, action: PayloadAction<boolean>) => {
            state.isFromKnowledgeGapReport = action.payload;
        },
        clearFetchEventsState: (state) => {
            state.selectedDateRange = DEFAULT_DATE_RANGE;
            state.selectedEventSubCategoryName = undefined;
            state.isFromKnowledgeGapReport = false;
        }
    },
})

export const { setSelectedDateRange, setSelectedEventSubCategoryName, setIsFromKnowledgeGapReport, clearFetchEventsState } = fetchEventsSlice.actions;
export default fetchEventsSlice.reducer;